// React
import React from 'react';
import { useSelector } from 'react-redux';
import i18next from 'i18next';

// Assets
import { CDN_LINK } from '../../assets/img';

// Components
import LoginCiam from './Login/loginCiam';

// Utils
import { getDeviceClass } from '../../utils';

// Css
import './login-provider.scss';

const LoginProvider = (props) => {
  const { content } = useSelector((state) => {
    return {
      content: state.ContentReducer.content
    };
  });
  const deviceClass = getDeviceClass();
  
  return (
    <div className={`login-provider-container ${deviceClass}`}>
      <div className={'welcome-banner__strap'} />
      <div className={'welcome-banner'}>
        <div className={'welcome-message'}>
          <LoginCiam {...props} />
        </div>
        <div className={'welcome-image-grid'}>
          <div className={'welcome-image-container'}>
            <div>
              <img
                className={'welcome-image-background'}
                src={`${CDN_LINK}/${content?.components?.login?.banner_1}`}
                alt={i18next.t('LANDING_PAGE.WELCOME')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginProvider;
